export const main = {
	yhxm:'User Name',
	qrxx:'Confirm Information Completion',
	mmdl:'Pwd Login',
	yzmdl:'Code Login',
	sjhm:"Mobile Number",
	qsrmm:'Enter Password',
	wjmm:'Forgot Password',
	dl:'Login',
	zcxzh:'Register New Account',
	yzm:'Code',
	hqyzm:'Get Code',
	sryx:'Enter Email',
	zcsrmm:'Re-enter Password',
	yqm:"Please enter the invitation code/inviter's phone number",
	sjyz:'Mobile Verification',
	yxyz:'Email Verification',
	tyxyhzc:'Agree to User Agreement & Privacy Policy',
	ty:'I Have Read And Agree',
	yhxy:'User Agreement',
	yszc:'Privacy Policy',
	zce:'Register',
	zyzhljdl:'Login Now',
	wdzc:'My Assets',
	wdzh:'My Account',
	tbgl:'Sync Management',
	fbxh:'Publish Signal',
	xhsc:'Signal Market',
	czsc:'Operation Manual',
	tcxh:'Exit Signal',
	ye:'Balance',
	jz:'Net Value',
	jyss:'Trading Lots',
	ccyl:'Position Profit',
	xvh:'No.',
	sftb:'Sync Status',
	fwq:'Server',
	zh:'Account',
	zyk:'Total P&L',
	kds:'Orders Opened',
	zhzt:'Account Status',
	cz:'Operation',
	s:'Yes',
	f:'No',
	zc:'Normal',
	yc:'Abnormal',
	ck:'View',
	cpyk:'Product P&L',
	zss:'Total Lots',
	jypz:'Trading Symbol',
	sy:'Profit',
	sszb:'Lots Proportion',
	cczh:'Positions Summary',
	ddh:'Order No.',
	jyl:'Trading Volume',
	kcsj:'Open Position Time',
	kcjg:'Open Price',
	bjjg:'Mark Price',
	zyzs:'TP/SL',
	gylx:'Overnight Interest',
	yk:'Profit/Loss',
	xzcksj:'Select Account Data',
	tbyk:'Sync P&L',
	ccsj:'Holding Period',
	pcsj:'Close Position Time',
	tjzh:'Add Account',
	bz:'Remark',
	sfwxh:'Is Signal',
	tbzt:'Sync Status',
	ytb:'Synced',
	wtb:'Not Synced',
	qyjy:'Enable/Disable',
	yqy:'Enabled',
	yjy:'Disabled',
	xgzhmm:'Change Password',
	gbxh:'Close Signal',
	sczh:'Delete Account',
	qw:'Go To',
	y:'Page',
	tjglzh:'Add Linked Account',
	qxz:'Please Select',
	qsrzh:'Enter Account',
	mm:'Password',
	qsrbz:'Enter Remark',
	sjsqxhts:'Upgrade to Community Signal',
	qr:'Confirm',
	qx:'Cancel',
	zhjy:'Disable Account?',
	zhqy:'Enable Account?',
	dqdlmm:'Current Login Password',
	xzhmm:'New Account Password',
	qrxmm:'Confirm New Password',
	qsrdqdlmm:'Enter Current Password',
	qsrxmm:'Enter New Password',
	qzcsrxmm:'Re-enter New Password',
	yhzl:'User Profile',
	jcxx:'Basic Info',
	tx:'Avatar',
	sczp:'Upload Photo',
	tudxxz:'Image Requirements: 413*626px, JPG/PNG <2MB',
	gjhdq:'Country/Region',
	dzyx:'Email',
	bcxg:'Save Changes',
	zhaq:'Account Security',
	dqmm:'Current Password',
	xmm:'New Password',
	qrmm:'Confirm Password',
	qsrdqmm:'Enter Current Password',
	qd:'OK',
	tjtb:'Add Sync',
	tb:'Sync',
	xh:'Signal',
	qsrnr:'Enter Content',
	tbzh:'Sync Account',
	qxztbzh:'Select Sync Accounts',
	jygz:'Trading Rules',
	bzjdb:'Margin Ratio',
	jzdb:'Equity Ratio',
	kyzjdb:'Available Funds Ratio',
	jyldb:'Trading Volume Ratio',
	gdssdb:'Fixed Lots Ratio',
	jycs:'Trading Parameters',
	kcjybc:'Open Price Compensation',
	xhsxzdpc:'Auto Close on Signal Failure',
	zdss:'Max Lots',
	zdhc:'Max Drawdown',
	jsbz:'Contract Standards: FX(100K), Gold(100oz), Silver(5Koz), Oil(1Kbbl)',
	pctbts:'Partial Close Not Supported',
	tbxh:'Sync Signal',
	tbms:'Sync Mode',
	tbxs:'Sync Coefficient',
	tbsz:'Sync Settings',
	xgcs:'Modify Parameters',
	yzttb:'Sync Paused',
	ykqtb:'Sync Active',
	sctb:'Delete Sync',
	xgtbcs:'Modify Sync Parameters',
	cgtbzt:'Change Sync Status',
	sfqkzhdtb:'Enable Sync?',
	sfztzhdtb:'Pause Sync?',
	tjxh:'Add Signal',
	nsyl:'Annual Yield',
	zt:'Status',
	dyz:'Subscribers',
	kstbsj:'Sync Start Time',
	zwsj:'No Data',
	xzzh:'Select Account',
	qxzzh:'Select Account',
	qqdxhhtbzzt:'Confirm Signal Status',
	xhm:'Signal Name',
	qsrxhm:'Enter Signal Name (≤15 chars)',
	xhmts:'Signal Name: Unique & Unchangeable',
	gszzdjz:'Follower Min Equity',
	sfgkxh:'Public Signal?',
	gk:'Public',
	sm:'Private',
	gsddzs:'Follow Order Comment',
	gsddzsts:'Visible on MT Order Notes',
	jdzyjgyhkf:'Pro/Institutional Only',
	xhms:'Signal Description',
	shili: 'Example: the account owner makes short-term, intraday orders with profit and loss stop only. It is recommended to synchronize the number of $2000 hands 1:1!',
	clmsts: 'To protect the privacy of all users, the policy description is not allowed to contain any contact information',
	xhlb: 'Signal list',
	xhlbts: 'Note: the signal providers are all third-party users, and the synchronization service may be delayed. All transaction data are collected from mt4/mt5 servers',
	xhy: 'signal source',
	zongsyl: 'Total yield',
	zhousyl: 'Weekly yield',
	jqtjycs: 'Number of transactions in recent 7 days',
	irrqzsy: 'IRR weighted return',
	zdhc2: 'Maximum withdrawal (%)',
	zq: 'Period (days)',
	jbsj: 'Basic data',
	fx: 'share',
	sc: 'collection',
	ysc: 'Collected',
	zsy: 'Total revenue',
	zrj: 'Total income',
	zcj: 'Total withdrawal',
	zdhcl: 'Maximum withdrawal rate (value)',
	zdfk: 'Maximum floating loss',
	zdds: 'Total orders',
	dbzdjyl: 'Maximum single transaction volume',
	t: 'day',
	zhhbdw: 'Account currency unit',
	ckqb: 'View all',
	anyue: 'monthly',
	jidu: 'quarter',
	bannian: 'Half a year',
	yinian: '1 year',
	ernian: '2 year',
	sanian: '3 year',
	jzye: 'Net worth/balance ($)',
	crj: 'Deposit and withdrawal ($)',
	cj: 'Withdrawal',
	rj: 'Deposit',
	ysyl: 'Monthly return rate',
	yiyue: 'January',
	eryue: 'February',
	sanyue: 'March',
	siyue: 'April',
	wuyue: 'May',
	liuyue: 'June',
	qiyue: 'July',
	bayue: 'August',
	jiuyue: 'September',
	shiyue: 'October',
	shiyiyue: 'November',
	shieryue: 'December',
	ccxj: 'Position Details',
	cq: 'product',
	dk: 'Many/Empty',
	ss: 'LOTS',
	yk2: 'Profit/Loss',
	hlzb: 'Measuring indicators',
	ylddcxsjpj: 'Profit order holding time',
	ksddcxsjpj: 'Holding time of loss orders',
	dgddylpj: 'Single order profit',
	dgddkspj: 'Single order loss',
	dgddlrzd: 'Single order profit',
	dgddkszd: 'Single order loss',
	syl: 'Yield rate',
	sjbl: 'Data Scale',
	sl: 'winning rate',
	zdjybl: 'Automatic trading ratio',
	pcddmx: 'Closing Order Details',
	pcjg: 'close rate ',
	sxf: 'commission',
	tbxtccsc: 'Synchronization System Operation Manual',
	zhzc: 'Account registration',
	xtdl: 'System Login',
	jzhszwxh: 'Set the account as a signal?',
	sztbxh: 'Set synchronization signal',
	wzjs: "JCLH consolidates multiple accounts across traders under MT4 or MT5 on the platform for vertical management, and provides users with services such as data aggregation, risk analysis, financial consolidation, information sharing, and inter account data synchronization for all accounts.",
	mzsmText:`<p  style="font-weight: bold; color: windowtext; text-align: center; ">
		<strong><span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
		免责声明</span>
		</strong>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明是由 JCLH与在网站www.JCLH.com上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		   <span>
				
				本网站已采取谨慎的措施对信息进行核实，但并不保证所含信息全部准确。请您理解我们的信息可能会不全面，或有疏漏或滞后。本网站或独立信息提供者均不会对任何因信息错误、不完整、迟延、不精确或基于对本网站信息的依赖而产生的损失承担任何责任。所有预测或观点(如未来汇率变动的预测)以及基于这些预测而进行的交易活动，仅代表第三方的个人观点和行为，并不代表本网站的立场。您须理解，第三方的预测不代表任何形式的业绩承诺，请不要直接或者间接地效仿。您必须进行独立分析以做出投资判断，同时应了解，在基于本网站内容做出判断所进行的投资行为可能产生实际的盈利或亏损。您基于本网站提供的交易策略和信号，运用个人配置交易系统所做出的投资行为是您自己决定的结果，需自行承担所有风险。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		  
				
				本网站明确表明，本网站的管理平台仅适用于对高风险投资有一定了解的用户。您可以使用空闲的资金进行投资，而不应该影响到日常生活的开支。任何交易策略在过去取得的业绩均不能代表其将来的表现。一般未来汇率变动是不可预测的，这也就表明任何个人策略、金融顾问、手动或者自动交易系统都不能保证任何形式的预测可能产生利润，所以对待投资预测一定要经过自己的分析做出判断，切忌盲从。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;"><span>基于网站或网络传输延时可能导致数据存在偏差（包括但不限于可能由于交易员修改密码或其他网络原因导致的账户断连造成订单跟随关系丢失），因此，用户在使用交易系统、交易跟随系统形成、产生交易后，应及时查看交易系统中交易数据的变化。无论是 JCLH 或是本网站任何合作伙伴都不能保证，您基于 JCLH 提供的信息及使用个人配置交易系统进行投资一定会盈利。除此之外， JCLH 作为跟随交易系统的开发者，不会对任何由于第三方(如作为这项服务的提供者公司或者交易商)延误、疏忽而导致的客户损失承担责任。除了以上， JCLH 明确表明不会对交易员提供的策略和交易信号承担任何责任。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				JCLH 所属公司注册所在地法律、法规应适用于本声明以及管辖本声明各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				在合约一方寻求实现本声明下的权利，或寻求宣告本声明下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。
			   
			</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明的解释语言应为中文。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
	`,
	yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
			<strong>
				<span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
					隐私政策
				</span>
			</strong>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1. 我们收集的信息类型
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
	
				我们主要收集三类信息。
			</span>
		</p>
	
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
	
				1.1 您向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
	
				使用 JCLH 的必要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
	
				当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.1 账号信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.2 您选择向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				交易风控信息。您可选择提供设置账户交易时使用的风控策略。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.2 您使用 JCLH 时，我们自动收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Cookies 及类似技术。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.3 我们通过第三方收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如：交易商信息、账户名、只读密码、交易数据等）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.我们如何使用所收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.1 创建和维护一个受到信任的以及更安全的环境
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				检测和预防欺诈、滥用、安全事件及其他有害活动。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				开展安全调查和风险评估。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				执行我们的服务条款及其他政策。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.分享与披露
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.1 征得您的同意
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.2 业务转移
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.3汇总信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.其他重要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.1 关联第三方账号
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.您的权利
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.1 管理您的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.2 不准确或不完整的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.4 数据保留与删除
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				请注意，如果您申请删除您的个人信息：
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				6. 全球运营
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				7.安全
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				8.本《隐私政策》的变更
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				9.联系我们
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
			</span>
		</p>
	`,
	fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
		<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.com 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户：中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
		</p>
		<p>
		<br/>
	</p>`,
	mzsmbt: "Disclaimer",
	qwzxcz: "To ensure account copy income, please do not operate on your own! ",
	wdzl: "My profile",
	wdqb: "My wallet",
	hyfw: "Membership Services",
	wdtd: "My Team",
	tcdl: "Log out",
	xhgl: "Signal Management",
	sfgz: "Charging rules: Pricing is based on a 1:1 ratio of funds and signal funds; User subscription fees are dynamically updated and deducted on a daily basis. ",
	jcdyf: "Basic subscription fee",
	yhdyf: "User subscription fee",
	zhye: "Account balance",
	xhye: "Signal balance",
	yf: "Month",
	bkxzjygz: "Currently, no trading rules can be selected",
	bksrjycs: "Currently unable to input transaction parameters",
	hand: "hand",
	pcjl: "Closing Record",
	tdxx: "Team Information",
	wdyqm: "My invitation code",
	fz: "Copy",
	yqmsjh: "Recommended invitation code/phone number",
	bang: "Binding",
	agree: 'I agree',
	mzsm: "Disclaimer",
	and: "And",
	fwtk: "Terms of Service",
	qhyy: "Switch language",
	zhong: "Chinese",
	ying: "English",
	wei: "Uyghur language",
	tai: "Thai",
	han: "Korean",
	ri: "Japanese",
		
	kyye: "Available Syncoin balance",
	yets: "Syncoin is a token that can only be used in the JCLH community and cannot be transferred or redeemed between users. Operated by JCLH. Obtained by redeeming points through purchase. Syncoin can be used to pay subscription fees, redeem prizes, and engage in other on-site activities. For details, please refer to the 'Syncoin Purchase and Use Agreement'",
	zffs: "Payment method",
		
	szhb: "Digital Currency",
	wxzf: "WeChat Pay",
	zfb: "Alipay",
	yl: "UnionPay",
	xyk: "Credit card",
	szjl: "Revenue and expenditure records",
		
	szsj: "Time",
	szsl: "Quantity",
	szxm: "Project",
	szzt: "Order Status",
	szbh: "Order number",
		
	dqdj: "Current level",
	yxq: "Valid until",
	shengj: "Upgrade",
	hygm: "Welcome to purchase SYNC membership",
	zfje: "Payment amount",
	xfjl: "Consumption Record",
	xfje: "Amount",
	
	dzgl:"association",
	dzg:"piece",
	dzzh:"account",
	
	a1:'Purchase Quantity',
	a2:'Membership Level',
	a3:'Account Quantity',
	a4:'Operation',
	a5:'Documents to be Uploaded',
	a6:'Payment Successful',
	a7:'Payment Failed',
	a8:'Upload Documents',
	a9:'View Payment',
	a10:'Payment',
	a11:'Digital Currency',
	a12:'Wallet Address',
	a13:'Copy Address',
	a14:'Copy Wallet Address for Payment',
	a15:'QR Code',
	a16:'Amount',
	a17:'Confirm',
	a18:'Cancel',
	a19:'Close',
	a20:'Copy Successful',
	a21:'Upload Documents',
	a22:'View Documents',
	a23:'Pending Review',
	
	a24:'Margin Proportion',
	a25:'Net Value Proportion',
	a26:'Available Funds Proportion',
	a27:'Trading Volume Proportion',
	a28:'Fixed Lot Size Proportion',
	a29:'Reverse Copy Trading',
	a30:'Position Opening Compensation',
	a31:'Position Closing Compensation',
	a32:'Selected',
	a33:'Whether to Enable the Current Account',
	a34:'Whether to Suspend the Current Account',
	a35:'Synchronized Operation',
	a36:'Limit to One Account',
	a37:'No Limit on the Number of Accounts Purchased',
	
	a38:'Trial Version Member',
	a39:'Basic Version Member',
	a40:'Professional Version Member',
	a41:'Institutional Version Member',
	a42:'Please set mobile phone number',
	a43:'Please set email address',
	a44:'Please enter the invitation code',
	a45:'The uploaded avatar image can only be in JPG format!',
	a46:'The size of the uploaded avatar image cannot exceed 2MB!',
	a47:'No synchronized data yet',
	a48:'Total number of lots',
	a49:'Whether to set it as',
	a50:'Enable',
	a51:'Disable',
	a52:'Status',
	a53:'Are you sure you want to delete this account?',
	a54:'Copied!',
	
	a55:'Please enter transaction parameters',
	a56:'The new password does not match the confirmation password!',
	a57:'Daily Income',
	a58:'Average',
	a59:'Maximum',
	a60:'Refresh successful',
	a61:'Productivity',
	a62:'Unqualified',
	a63:'Qualified',
	a64:'Winning Rate',
	a65:'Withdrawal',
	a66:'Deposit',
	a67:'Balance',
	a68:'Net Value',
	a69:'Daily Profit/Loss',
	a70:'Please enter a value',
	a71:'This signal has no synchronizers yet',
	
	a72:'Login status has expired, please log in again!',
	a73:'The SMS has been sent, please check and receive it.',
	a74:'The verification code has been sent!',
	a75:'Login successful!',
	a76:'User Name cannot be empty',
	a77:'Mobile phone number cannot be empty',
	a78:'Have not agreed to the User Agreement and Privacy Policy',
	a79:'Member Upgrade',
	a80:'Select Type',
	a81:'Current validity period until',
	a82:'Converted validity period until',
	a83:'Note: The converted validity period is automatically calculated by the system.',
	a84:'Drag the file here',
	a85:'Or',
	a86:'Click to upload',
	a87:'You are already a top-level member and cannot upgrade further.',
	a88:'Under review',
	a89:'This payment method is not supported temporarily',
	a90:'Reset Password',
	a91:'Remembered',
	a92:'United States',
	a93:'China',
	a94:'Hong Kong',
	
	a95:'Risk Warning',
	a96:'This Intelligent Quantitative Community mainly provides standardized trading signals for users reference.',
	a97:'To ensure strategy effectiveness and control execution deviation',
	a98:'It is recommended that the fund size for a single quantitative target shall not be less than 20000 USD',
	a99:'If the invested capital is below this benchmark, the relative risk may be amplified due to insufficient fund size, affecting strategy stability.',
	a100:'Please, before starting any operation, be sure to base it on your own financial situation and risk tolerance.',
	a101:'Set up the accounts risk protection mechanism by yourself.',
	a102:'All quantitative trading activities are your personal independent decisions, and the relevant profits and losses as well as losses caused by force majeure factors such as market fluctuations, system malfunctions, policy changes, etc.',
	a103:'All shall be borne by yourself.',
	a104:'The signals provided by this community are for information reference only.',
	a105:'It does not constitute investment advice, offer, or guarantee.',
	a106:'This Intelligent Quantitative Community',
	a107:'Shall not be liable for any trading results or fund losses.',
	a108:'Please fully understand and confirm acceptance of the above risks before proceeding with operations.',
	a109:'I Have Understood',
	
	zhlb:'Account List',
	
	a110:'No Level Yet',
}
				